// Documentary mode chapter list. Shared between the runtime player
// (src/main.js) and the build-time narration generator
// (scripts/generate-narration.js) so the script knows exactly what
// text to send to ElevenLabs and the player knows where to find the
// resulting audio.
//
// `duration` is a fallback only — used if narration audio failed to
// generate (no API key, dev environment, etc). With audio present, the
// chapter advances on the audio's `ended` event instead.

export const DOCUMENTARY_CHAPTERS = [
  {
    id: 'sun',
    label: 'The Sun',
    duration: 18000,
    narration: 'The star at the centre of it all. A 5,778-kelvin ball of plasma, four and a half billion years old, so massive every planet in this system orbits inside its gravity. Every second, it turns four million tons of matter into pure energy. Without it, nothing here would exist.'
  },
  {
    id: 'mercury',
    label: 'Mercury',
    duration: 14000,
    narration: 'The closest world to the sun. A scorched, airless rock not much larger than our moon, with days that burn hotter than a furnace and nights colder than liquid nitrogen. A planet with no atmosphere to soften the extremes.'
  },
  {
    id: 'venus',
    label: 'Venus',
    duration: 15000,
    narration: "Earth's twin in size, but a runaway greenhouse. Surface temperatures hot enough to melt lead, clouds of sulfuric acid, the hottest world in the solar system despite being further from the sun than Mercury. A cautionary tale wrapped in yellow haze."
  },
  {
    id: 'earth',
    label: 'Earth',
    duration: 18000,
    narration: "The pale blue dot. The only world we know of where life took hold. Water oceans, breathable air, a magnetic field that shields the surface from solar radiation. Everything you've ever known, every person who ever lived, every story ever told — happened here."
  },
  {
    id: 'mars',
    label: 'Mars',
    duration: 15000,
    narration: 'The red planet. Named for the god of war for its rust-coloured surface, stained by iron oxide. Once it had rivers, lakes, maybe even oceans. Today it is cold, dry, and quiet, but it may still hold life buried beneath the frozen soil.'
  },
  {
    id: 'jupiter',
    label: 'Jupiter',
    duration: 18000,
    narration: 'The giant. More massive than all the other planets combined. A gas giant with no solid surface, wrapped in storms that last centuries. The Great Red Spot alone could swallow Earth whole. Its moons — Io, Europa, Ganymede, Callisto — are worlds in their own right, each with its own mystery.'
  },
  {
    id: 'saturn',
    label: 'Saturn',
    duration: 18000,
    narration: 'The jewel of the solar system. Its rings are made of billions of chunks of ice and rock, some the size of grains of dust, others larger than mountains. A world 95 times the mass of Earth, so light it would float on water if you could find an ocean big enough.'
  },
  {
    id: 'uranus',
    label: 'Uranus',
    duration: 14000,
    narration: 'The sideways planet. Tipped over on its side, possibly by an ancient collision, so it rolls through its orbit rather than spinning upright. An ice giant, methane in its atmosphere gives it that pale cyan colour. Only one spacecraft has ever visited: Voyager 2, in 1986.'
  },
  {
    id: 'neptune',
    label: 'Neptune',
    duration: 14000,
    narration: 'The deepest blue. The windiest planet in the solar system, with supersonic gales at the edge of its atmosphere. Four and a half billion kilometres from the sun, so far that from here our star is just a bright point of light, indistinguishable from the background stars.'
  },
  {
    id: 'pluto',
    label: 'Pluto',
    duration: 14000,
    narration: 'Once the ninth planet, now classified as a dwarf. Five billion kilometres away, in the Kuiper belt on the cold fringe of the solar system. Its surface has mountains of water ice and a thin nitrogen atmosphere. A world we have only seen up close once, when New Horizons flew past in 2015.'
  },
  {
    id: 'outro',
    label: 'End',
    duration: 14000,
    // Returns to the full system view (handled in main.js as a special
    // case: if the chapter id is 'outro', returnToOverview is called
    // instead of focusing on a body).
    narration: 'That is our cosmic neighbourhood. One star, eight planets, a dwarf, and countless worlds in between. Thank you for watching. If you enjoyed this, follow @voidmode on Twitter for more. This has been a presentation by Polyxmedia.'
  }
];
